import { type Price } from '@commercetools/platform-sdk'
import PlentyBody from '#app/components/typography/plenty-body'
import { moneyFormatWithTypedMoney } from '#app/utils/money'

type BagPriceTagProps = {
	price: Price
}

export const BagPriceTag = ({ price }: BagPriceTagProps) => {
	const isDiscounted = Boolean(price?.discounted?.value)
	const priceToShow = isDiscounted ? price?.discounted?.value : price?.value
	// If neither discounted nor original price is available, show a fallback message
	if (!priceToShow) {
		return <div>Price not available</div>
	}

	// Format the displayed price and the original price (if discounted) for display
	const formattedPriceToShow = moneyFormatWithTypedMoney(priceToShow)
	const formattedOriginalPrice = isDiscounted
		? moneyFormatWithTypedMoney(price.value)
		: null

	return (
		<div className="flex items-center space-x-2 md:space-x-4">
			<span>
				<PlentyBody
					size="sm"
					className={`font-${isDiscounted ? 'bold' : 'regular'} text-${
						isDiscounted ? 'text-red' : 'text-beige-100'
					}`}
				>
					{formattedPriceToShow}
				</PlentyBody>
			</span>
			{isDiscounted && formattedOriginalPrice && (
				<span className=" text-green-40 line-through md:inline">
					<PlentyBody size="sm" className="text-green-40">
						{formattedOriginalPrice}
					</PlentyBody>
				</span>
			)}
		</div>
	)
}
